<template>
<div id="secure">
    <section class="main-content columns is-fullheight vld-parent">
        <SideMenu />

        <div class="container column is-9">
            <loading :active.sync="isLoading" 
                :can-cancel="false" 
                :is-full-page="fullPage">
            </loading>

            <div class="section">         

                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Download QR Tags for students</p>
                    </div>
                    <div class="card-content">
                        <div class="content"><button class='button is-primary' v-on:click="downloadQRTags()">
                            Download QR Tags
                        </button></div>
                    </div>
                </div>
                <br />
                
                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Import Students from excel (xlsx)</p>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            <b-field class="file">                      
                                <b-upload v-model="file">
                                    <a class="button is-primary">
                                        <i class='upload icon'></i>
                                        <span>Import students from excel</span>
                                    </a>
                                </b-upload>
                                <span class="file-name" v-if="file">{{ file.name }}</span>
                                <b-select placeholder="Select class" id="kelasID" name="kelasID" v-model="input.kelasID">
                                    <option v-for="kelas in kelasList" v-bind:value="kelas._id" v-bind:key="kelas._id">{{ kelas.level }} {{ kelas.name }}</option>
                                </b-select>
                                <button class='button is-info' v-on:click="uploadExcel()">
                                    Upload now
                                </button>
                            </b-field>
                            <a class="button is-warning" v-on:click="downloadTemplate()">Download Excel (xlsx) template</a>                       
                        </div>
                    </div>
                </div>
                <br />

                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Add New Student</p>
                    </div>
                    <div class="card-content">
                        <div class="content"><data-create></data-create></div>
                    </div>
                </div>
                <br />

                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Students</p>
                    </div>
                    <div class="card-content">
                        <div class="content"><data-list v-bind:dataList="dataList"></data-list></div>
                    </div>
                </div>
                <br />

            </div>
        </div>
    </section>
</div>
</template>

<script>
import SideMenu from '../SideMenu'
import axios from 'axios'
import DataList from '../Students/DataList';
import DataCreate from '../Students/DataCreate';

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { ToastProgrammatic as Toast } from 'buefy'


export default {
    name: 'StudentsMain',
    components: {
        DataList,
        DataCreate,
        SideMenu,
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            input: {
                kelasID: null,
            },
            result: "",
            errors: [],
            dataList: [{
                firstName: '',
                lastName: '',
                done: false,
            }],
            file: null,
            kelasList: []
        }
    },
    created() {
        this.getStudents()
        this.getClasses()
    },
    beforeMount() {
        this.$emit("authenticated", true)
        console.log('before mount in StudentsMain')
        console.log("tokennn? " + localStorage.getItem('jwtToken'))
        console.log("sessionID? " + localStorage.getItem('sessionID'))
    },
    methods: {   
        getStudents() {
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/students/list', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        category: 'school',
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    this.dataList = response.data
                    console.log(this.dataList)
                })
                .catch(e => {
                    this.errors.push(e)
                    console.log(e)
                })
        },
        getClasses(){               
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.post(process.env.MY_URL + '/api/auth/kelas/list', {
                params: {
                    email: localStorage.getItem('email'),
                    sessionID: localStorage.getItem('sessionID')
                }
            })
            .then(response => {
            // JSON responses are automatically parsed.
                this.kelasList = response.data
            })
            .catch(e => {
                this.errors.push(e)
                console.log(e)
            })
        },
        uploadExcel(){
            console.log("Entering uploadExcel")
            console.log(this.input.kelasID)
            console.log(this.file)
            if (this.input.kelasID != null &&  this.file != null){
                this.isLoading = true;

                let formData = new FormData();                
                formData.append('email', localStorage.getItem('email'));
                formData.append('sessionID', localStorage.getItem('sessionID'));
                formData.append('file', this.file);
                formData.append('kelasID', this.input.kelasID);

                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.post(process.env.MY_URL + '/api/students/import',
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(response => {
                    console.log('SUCCESS!!');
                    console.log(response)
                    if (response.data.success == true) {
                        console.log("Students imported!")
                        this.file = null
                        this.input.kelasID = null
                        this.isLoading = false
                        
                        Toast.open({
                            color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            message: response.data.msg,
                            type: 'is-success',
                            duration: 3000
                        })

                        this.getStudents();
                    } else {
                        Toast.open({
                            message: response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                        this.isLoading = false
                        console.log(response.data.msg)
                        this.errors.push(response.data.msg)
                    }
                })
                .catch(e => {
                    console.log(e.response)
                    Toast.open({
                        message: e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                    this.errors.push(e)
                    this.isLoading = false
                });

            }else{
                alert("Please select the excel file you want to upload, the class you want to import into and the overwrite option.")
                return false;
            }
        },
        downloadTemplate(){
            var downloadLink = "http://" + window.location.hostname + "/downloads/template_students.xlsx";
            window.open(downloadLink,"_blank")
        },
        downloadQRTags(){
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'blob'
            axios.post(process.env.MY_URL + '/api/students/qr_multiple', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID')
                    }
                })
                .then(response => {                    
                    console.log("241 reponse")
                    console.log(response)
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'tags.pdf'); //or any other extension
                    document.body.appendChild(link);
                    link.click();

                    // let blob = new Blob([response.data], { type: 'application/pdf' }),
                    // url = window.URL.createObjectURL(blob)

                    //     window.open(url) 

                    // this.dataList = response.data
                    // console.log(this.dataList)
                })
                .catch(e => {
                    this.errors.push(e)
                    console.log(e)
                })
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Students/Main.vue